import axiosInstance from './axiosConfig';

export interface VideoPromptFavorite {
  id: number;
  user_id: number;
  prompt: string;
  label: string | null;
  usage_count: number;
  created_at: string;
  updated_at: string;
}

export interface PromptHistory {
  id: string;
  prompt: string;
  video_model: string;
  aspect_ratio: string;
  status: string;
  created_at: string;
}

const videoPromptService = {
  async getFavorites(): Promise<VideoPromptFavorite[]> {
    const response = await axiosInstance.get('/videos/prompts/favorites');
    return response.data.favorites;
  },

  async saveFavorite(prompt: string, label?: string): Promise<VideoPromptFavorite> {
    const response = await axiosInstance.post('/videos/prompts/favorites', { prompt, label });
    return response.data.favorite;
  },

  async deleteFavorite(id: number): Promise<void> {
    await axiosInstance.delete(`/videos/prompts/favorites/${id}`);
  },

  async getHistory(): Promise<PromptHistory[]> {
    const response = await axiosInstance.get('/videos/prompts/history');
    return response.data.history;
  },
};

export default videoPromptService;
